import React, { useContext } from 'react';
import { View } from 'react-native';
import { Button } from '@rneui/themed';
import { H1 } from '../../text';
import LayoutContext from '../../../contexts/Layout';

export const Toolbar = props => {
    const { label, onNavigate } = props;
    const { layout } = useContext(LayoutContext);

    return (
        <View style={{ alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between', marginBottom: 10, marginHorizontal: 10 }}>
            <Button
                containerStyle={{ backgroundColor: '#153d6e', marginRight: layout.styleGuide.spacer9 }}
                onPress={() => onNavigate('TODAY')}
                title='Today'
                titleStyle={{ color: '#fff' }}
            />
            {layout.device.isDesktopOrLaptop && <H1 style={{ textAlign: 'left' }} text={label} />}
            <View style={{ alignSelf: 'flex-end', flexDirection: 'row' }}>{props.children}</View>
        </View>
    );
};
